(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/banner-helpers/assets/javascripts/other.js') >= 0) return;  svs.modules.push('/components/banner_common/banner-helpers/assets/javascripts/other.js');

'use strict';

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var trinidadCore = isServer && require('trinidad-core').core;


var escapeHtml = function escapeHtml(input) {
  var replacingChars = function replacingChars(match) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;'
    }[match];
  };
  return input === null || input === void 0 ? void 0 : input.replace(/[&<>"]/g, replacingChars);
};
var getCallToAction = function getCallToAction(action) {
  var viewConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  action = _objectSpread(_objectSpread({}, action), {}, {
    actionConfig: _objectSpread(_objectSpread({}, action.actionConfig), {}, {
      viewConfig: viewConfig
    })
  });
  return action;
};
var getIsAdmin = function getIsAdmin(req) {
  var _ref = (isServer ? req.userSession : svs.core.userSession) || {},
    roles = _ref.roles;
  return isServer ? req.userSession.hasRole(roles.INTERNAL) : svs.core.userSession.hasRole(roles.INTERNAL);
};
var getIsPreview = function getIsPreview(req) {
  var _ref2 = isServer ? req.userSession : svs.core.userSession,
    roles = _ref2.roles;
  return !isServer && svs.core.data.roles.includes(roles.INTERNAL);
};

var groupNumbers = function groupNumbers(text) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var wrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '<span class="inline-block">$&</span>';
  var output = (text === null || text === void 0 ? void 0 : text.replaceAll(/\d+(?:[ .,:-]\d+)*/g, wrapper)) || '';
  return config.escapeHtml ? escapeHtml(output) : output;
};
var getContentType = function getContentType(type) {
  return (type === null || type === void 0 ? void 0 : type.split(':').pop()) || 'banner';
};
var fallbackFunction = function fallbackFunction() {
  return '';
};
var getHbsCompiled = function getHbsCompiled(layoutType) {
  var _global, _svs$banner_layouts$l;
  var hbs = isServer && ((_global = global) === null || _global === void 0 || (_global = _global.internalInstances) === null || _global === void 0 ? void 0 : _global.get('hbs'));
  return isServer ? (hbs === null || hbs === void 0 ? void 0 : hbs.cache["components-banner_layouts-".concat(layoutType, "-").concat(layoutType)]) || fallbackFunction : ((_svs$banner_layouts$l = svs.banner_layouts[layoutType]) === null || _svs$banner_layouts$l === void 0 ? void 0 : _svs$banner_layouts$l.templates[layoutType]) || fallbackFunction;
};
var getNoscriptUrl = function getNoscriptUrl(fallbackImg) {
  return fallbackImg === null || fallbackImg === void 0 ? void 0 : fallbackImg.url;
};
var getTrackingString = function getTrackingString(inputTitle, layoutType, tracking) {
  var format = isServer ? trinidadCore.components.require('utils', 'format').api : svs.utils.format;
  var title = format.safeString(inputTitle) || inputTitle;
  var widget = tracking.widget,
    position = tracking.position;
  var output = [widget.widgetType, widget.trackingId, position, layoutType, title].join('/');
  return output;
};

var getRCTools = function getRCTools(_ref3) {
  var _res$locals, _svs$core, _model$layoutConfig;
  var layoutType = _ref3.layoutType,
    model = _ref3.model,
    res = _ref3.res,
    req = _ref3.req,
    tracking = _ref3.tracking;
  var contentType = getContentType(model.contentType);
  var hbsCompiled = getHbsCompiled(layoutType);
  var isAdmin = getIsAdmin(req);
  var isPreview = getIsPreview(req);
  var features = isServer ? (res === null || res === void 0 || (_res$locals = res.locals) === null || _res$locals === void 0 ? void 0 : _res$locals.features) || [] : ((_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.features) || [];
  var trackingString = getTrackingString(model.title, layoutType, tracking);
  var defaultThemeClass = 'default-transparent';
  var themeClass = ((_model$layoutConfig = model.layoutConfig) === null || _model$layoutConfig === void 0 ? void 0 : _model$layoutConfig.theme) || defaultThemeClass;
  var isThemeClassDefault = themeClass === defaultThemeClass;
  var getCallToActions = function getCallToActions(viewConfig) {
    return _toConsumableArray(model.callToActions).map(function (action) {
      return getCallToAction(action, viewConfig);
    });
  };
  return {
    contentType: contentType,
    features: features,
    getCallToActions: getCallToActions,
    hbsCompiled: hbsCompiled,
    isAdmin: isAdmin,
    isPreview: isPreview,
    isThemeClassDefault: isThemeClassDefault,
    themeClass: themeClass,
    trackingString: trackingString
  };
};
var other = {
  getCallToAction: getCallToAction,
  getNoscriptUrl: getNoscriptUrl,
  getRCTools: getRCTools,
  groupNumbers: groupNumbers
};
if (isServer) {
  module.exports = other;
} else {
  svs.banner_common.banner_helpers = _objectSpread(_objectSpread({}, svs.banner_common.banner_helpers), other);
}

 })(window);